<div 
    class="container-item" 
    [raTooltip]="{ text: text(), position: tooltipPosition() }" 
    [class.success]="type() === 'success'" 
    [class.danger]="type() === 'danger'">
            
    <!-- Left -->
    <div class="container-left">
        <!-- Ornamento: quem recebe o clique é a linha inteira -->
        <ra-square-icon
            [icon]="icon()"
            [interactive]="false"
        />

        <p>{{ text() }}</p>
    </div>

    <!-- Right -->
    <ra-icon icon="arrow-right" varColor="currentColor" [size]="20" />
</div>